export interface CustomerInformationDataWithPDF {
  customIdentifier: string;
  pdfFilesBorrower: FileList | null;
  personalDetails: {
    identity: {
      firstName?: string | null;
      lastName?: string | null;
    };
    contact: {
      email?: string | null;
      phoneNumber?: string | null;
    };
  };
  pdfFilesCoBorrower?: FileList | null;
  personalDetailsOfCoBorrower?: {
    identity: {
      firstName?: string | null;
      lastName?: string | null;
    };
    contact: {
      email?: string | null;
      phoneNumber?: string | null;
    };
  };
  hasCoBorrower?: boolean;
}

export interface CustomerInformationData {
  customIdentifier: string;
  personalDetails: {
    identity: {
      firstName?: string | null;
      lastName?: string | null;
    };
    contact: {
      email?: string | null;
      phoneNumber?: string | null;
    };
  };
  personalDetailsOfCoBorrower?: {
    identity: {
      firstName?: string | null;
      lastName?: string | null;
    };
    contact: {
      email?: string | null;
      phoneNumber?: string | null;
    };
  };
  hasCoBorrower?: boolean;
}

export interface InvitationResponse {
  customerId: string;
  sessionId: string;
}

export enum AutomaticSendType {
  EMAIL = 'email',
  SMS = 'sms',
}

export enum InvitationType {
  INVITATION_LINK_CREATED = 'invitation_link_created',
  INVITATION_LINK_RETRIEVED = 'invitation_link_retrieved',
  INVITATION_LINK_SENT = 'invitation_link_sent',
}

export interface InvitationHistory {
  date: string;
  type: InvitationType;
  channel?: AutomaticSendType;
  senderUsername?: string;
}

type MergedInvitationInformation = CustomerInformationData & InvitationResponse;

export interface InvitationCustomer extends MergedInvitationInformation {
  aggregationLink?: string;
}
